<section class="gallery-layout gallery-layout-2">
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <app-title [titles]="[title]" class="title" />
      <app-instagram />
      <div class="button">
        <app-button
          [icon]="{ color: 'BLACK', name: 'CHEVRON_RIGHT', position: 'RIGHT' }"
          label="Notre Instagram"
          url="https://www.instagram.com/perene_officiel" />
      </div>
    </div>
  </div>
</section>
